import { useEffect, type RefObject } from 'react';

/** Calls `onOutside` for clicks outside every given element while `active`. */
export function useOutsideClick(refs: RefObject<HTMLElement | null>[], onOutside: () => void, active: boolean) {
  useEffect(() => {
    if (!active) return;
    const h = (e: MouseEvent) => {
      const t = e.target as Node;
      if (refs.some((r) => r.current?.contains(t))) return;
      onOutside();
    };
    document.addEventListener('click', h);
    return () => document.removeEventListener('click', h);
  }, [active, onOutside, refs]);
}
